import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AuthService} from './service/auth/auth.service';
import {RouterGuardService} from './guard/router-guard/router-guard.service';
import {ConstantService} from './constant/constant.service';
import {PartnerService} from './service/partner/partner.service';
import {SpinnerComponent} from './spinner/spinner.component';
import {LoanService} from './service/loan/loan.service';
import {RangePipe} from './pipe/pipe/range.pipe';
import {UrlDataPipe} from './pipe/url-data.pipe';
import {LoanApplicationCustomerResolverService} from './resolver/loanApplicationCustomerResolver/loan-application-customer-resolver.service';
import {StateTransitionsCustomerService} from './helper/stateTransitions/state-transitions.customer.service';
import {ConnectionService} from './service/connection/connection.service';
import {ChatAssistantComponent} from './common-components/chat-assistant/chat-assistant.component';
import { CompileDirective } from './directives/compile.directives';
import { getDatePipe } from './pipe/pipe/getDate.pipe';
import { getNumFormatPipe } from './pipe/pipe/getNumFormat.pipe';
import { ListItemPipe } from './pipe/pipe/listItem.pipe';
import { LPadPipe } from './pipe/pipe/lpad.pipe';
import { SortPipe } from './pipe/pipe/sort.pipe';
import { KeyValuePipe } from './pipe/pipe/keyvalue.pipe';
import { NoRecordFoundComponent } from './common-components/no-record-found/no-record-found.component';
import { MaskedPipe } from './pipe/masked.pipe';
import { ListFilterPipe } from './pipe/listfilter.pipe';
import { DocumentViewerComponent } from './common-components/documentViewer/document-viewer.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    SpinnerComponent, 
    ChatAssistantComponent,
    NoRecordFoundComponent,
    RangePipe, 
    UrlDataPipe,
    getDatePipe,
    getNumFormatPipe,
    ListItemPipe,
    LPadPipe,
    SortPipe,
    KeyValuePipe,
    MaskedPipe,
    ListItemPipe,
    ListFilterPipe,
    CompileDirective,
    DocumentViewerComponent
  ],
  exports: [
    SpinnerComponent, 
    ChatAssistantComponent,
    NoRecordFoundComponent,
    RangePipe,
    UrlDataPipe,
    getDatePipe,
    getNumFormatPipe,
    ListItemPipe,
    LPadPipe,
    SortPipe, 
    UrlDataPipe,
    KeyValuePipe,
    MaskedPipe,
    ListItemPipe,
    ListFilterPipe,
    DocumentViewerComponent 
  ],
  providers: [
    AuthService,
    RouterGuardService,
    ConstantService,
    PartnerService,
    LoanService,
    LoanApplicationCustomerResolverService,
    StateTransitionsCustomerService,
    ConnectionService,
    DocumentViewerComponent
  ]
})
export class SharedComponentModule {

}
